import React, { Component } from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import { push } from 'connected-react-router'
import { Select, Input, Button, Checkbox } from 'loyal-react'

import moment from 'moment'

import { ModalTerms } from '../../CellphoneRecharge/ModalTerms'
import clients from 'redux/clients'
const {
  cloudloyalty: { client }
} = clients

const objectErrorDefault = { message: '', valid: null }
const errorsDefault = {
  barCode: objectErrorDefault,
  dueDate: objectErrorDefault,
  acceptedTerms: objectErrorDefault
}

class BillPayment extends Component {
  state = {
    vendorId: 21188,
    maskLengthAccountType: 51,
    maskAccountType: [],
    services: [],
    barCode: '',
    serviceId: '',
    dueDate: '',
    showTerms: false,
    isLoading: false,
    isSendingPurchase: false,
    errors: { ...errorsDefault },
    enableNextStep: true,
    firstStep: true,
    secondStep: false,
    stepError: false,
    stepFinal: false,
    acceptedTerms: false
  }

  componentWillMount () {
    this.loadServices()
  }

  getServiceSelected = () => {
    const { serviceId, services } = this.state
    return services.find(service => service.serviceId === serviceId)
  }

  loadServices = () => {
    client
      .get(`/v1/billPayments/vendor/${this.state.vendorId}/service`)
      .then(({ data: services }) => this.setState({ services }))
  }

  handleValidateDueDate = () => {
    const propName = 'dueDate'
    var dueDate = moment(this.state.dueDate, 'DD/MM/YYYY', true)
    if (dueDate.isValid()) {
      return this.setPropValidation(propName, { message: '', valid: true })
    }

    this.setPropValidation(propName, {
      message: 'Data de vencimento inválida.',
      valid: false
    })
  }

  handleValidateBarCode = ({ serviceId, barCode }) => {
    if (!serviceId || !barCode) return

    const handleFail = ({ response }) => {
      let message = 'Não foi possível validar o código de barra.'
      if (response && response.status === 422) {
        message = 'Código de barras inválido.'
      }

      this.setState({
        isLoading: false,
        errors: { ...this.state.errors, barCode: { message, valid: false } }
      })
    }

    const { vendorId } = this.state
    const url = `/v1/billPayments/vendor/${vendorId}/service/${serviceId}/validate/${barCode}`

    this.setState({ isLoading: true })
    client
      .get(url)
      .then(({ data }) => {
        this.setState({ ...data, isLoading: false })
        this.setPropValidation('barCode', { valid: true, message: '' })
      })
      .catch(handleFail)
  }

  handleSendPurchase = () => {
    const payment = {
      serviceId: this.state.serviceId,
      barCode: this.state.barCode,
      dueDate: moment(this.state.dueDate, 'DD/MM/YYYY').format('MM/DD/YYYY'),
      documentNumber: this.props.documentNumber,
      billValue: this.state.billValue
    }

    this.setState({ isSendingPurchase: true })

    client
      .post('/v1/purchases/billPayment', payment)
      .then(({ data: { id } }) => {
        this.setState({ isSendingPurchase: false })
        this.props.redirect(`/confirmation/${id}`)
      })
      .catch(({ response: { data: error } }) => {
        this.setState({ isSendingPurchase: false })
        this.props.redirect({
          pathname: '/billpayment',
          state: { ...this.state, hasError: true, error }
        })
      })
  }

  btnResetSteps = () => {
    this.setState({
      firstStep: true,
      secondStep: false,
      stepError: false,
      stepFinal: false
    })
  }

  btnBillPaymentNextStep = () => {
    this.setState({
      firstStep: false,
      secondStep: true,
      stepError: false,
      stepFinal: false
    })
  }

  btnTryAgain = () => {
    this.setState({
      firstStep: false,
      secondStep: true,
      stepError: false,
      stepFinal: false
    })
  }

  isFormInvalid = () => {
    const { errors } = this.state
    const propNames = Object.keys(errors)

    for (let index = 0; index < propNames.length; index++) {
      const propName = propNames[index]
      const isInvalid = !errors[propName].valid
      if (isInvalid) return true
    }
    return false
  }

  handleOnChangeAcceptTerms = () => {
    const acceptedTerms = !this.state.acceptedTerms
    this.setPropValidation('acceptedTerms', { valid: acceptedTerms })
    this.setState({ acceptedTerms })
  }

  setPropValidation = (name, value) => {
    const errors = { ...this.state.errors, [name]: value }
    this.setState({ errors })
  }

  handleBarCodeChange = ({ target: { value } }) => {
    const valueFormated = value.trim().match(/\d+/g)
    if (valueFormated) {
      const barCode = valueFormated.join([])
      this.setState({ barCode })
      return
    }
    this.setState({ barCode: value })
  }

  handleFormatValue = (value, decimal) => {
    if (!isNaN(value)) {
      return `${parseFloat(value).toLocaleString('pt-br', {
        minimumFractionDigits: decimal || this.props.decimalPlaces,
        maximumFractionDigits: decimal || this.props.decimalPlaces
      })} `
    }
    return ''
  }

  render () {
    const serviceSelected = this.getServiceSelected(this.state.serviceId)

    return (
      <div className='item-service col-12 col-md-8 col-lg-4 px-1 mb-lg-0 mb-3'>
        <div
          className='bx-paguecontas h-100 bg-white radius row px-2 mx-0 pt-3 pb-2'
          style={this.state.firstStep ? {} : { display: 'none' }}
        >
          <div className='col-12 my-3 pb-1'>
            <h4 className='txt-uppercase color-brand-6 txt-body-sm mb-1'>
              Pagamento de contas
            </h4>
            <h2 className='color-ui-white txt-title txt-circular-book'>
              Pague suas contas
              <br />
              com seus {this.props.pointsValue}.
            </h2>
          </div>
          <Select
            id='BillType'
            label='Tipo de conta'
            className='form-field col-12 mt-3 mt-md-5'
            hasEmpty
            displayValue='name'
            selectedValue='serviceId'
            options={this.state.services}
            required
            onChange={({ serviceId }) => {
              let defaultNotDigit = new RegExp(/[^ -//]/)
              let arrayRegularExpression = this.state.services.find(item => item.serviceId === serviceId).mask.split(',')
              let arrayMask = arrayRegularExpression.map(i => defaultNotDigit.test(i) ? new RegExp(i) : i)
              this.setState({
                serviceId,
                enableNextStep: false,
                maskAccountType: arrayMask,
                maskLengthAccountType: this.state.services.find(item => item.serviceId === serviceId).maskLength
              })
            }}
          />
          <Button
            id={'btnNextStepBillPayment'}
            name={'NextStepBillPayment'}
            className='btn-featured btn btn-sm mt-2 mx-1'
            text='Continuar'
            onClick={this.btnBillPaymentNextStep}
            disabled={this.state.enableNextStep}
          />
        </div>
        <div
          className='bg-white radius row px-1 mx-0 pt-2 pb-3 border-top-lg border-color-featured'
          style={this.state.secondStep ? {} : { display: 'none' }}
        >
          <div className='row px-1 mx-0'>
            <div className='col-10'>
              <p className='txt-body-sm my-1 nowrap'>
                {serviceSelected ? `Pague sua ${serviceSelected.name}.` : ''}
              </p>
            </div>
            <div className='col-2 pl-3'>
              <i
                className='icon icon_close txt-body-sm cursor'
                onClick={this.btnResetSteps}
              />
            </div>
            <Input
              id='BarCode'
              className='col-12 form-field mt-1'
              label='Digite o código de barras'
              required
              value={this.state.barCode}
              onChange={this.handleBarCodeChange}
              data-error={this.state.errors.barCode.message}
              valid={this.state.errors.barCode.valid}
              onBlur={() => this.handleValidateBarCode(this.state)}
              mask={this.state.maskAccountType}
              type='number'
            />

            <Input
              id='DueDate'
              name='DueDate'
              className='col-12 form-field mt-2'
              label='Vencimento'
              required
              mask={[
                /[0-3]/,
                /[0-9]/,
                '/',
                /[0-1]/,
                /[0-9]/,
                '/',
                /[1-2]/,
                /[0-9]/,
                /[0-9]/,
                /[0-9]/
              ]}
              onChange={({ target: { value: dueDate } }) => {
                this.setState({ dueDate })
              }}
              data-error={this.state.errors.dueDate.message}
              valid={this.state.errors.dueDate.valid}
              onBlur={() => this.handleValidateDueDate()}
            />

            <Input
              id='BillValue'
              label='Valor da conta'
              className='col-6 form-field mt-2'
              required
              value={this.handleFormatValue(this.state.billValue, '2')}
              disabled={this.state.isPriceEditable ? 'true' : 'false'}
            />

            <Input
              id='BillPoints'
              label={`Valor em ${this.props.pointsValue}`}
              className='col-6 form-field mt-2'
              required
              value={this.handleFormatValue(this.state.pointsValue)}
              disabled={this.state.isPriceEditable ? 'true' : 'false'}
            />

            <div className='col-12 row mx-0'>
              <Checkbox
                id='aceito_termos_bill_payment'
                className='col-auto'
                labelClass='l-0'
                checked={this.state.acceptedTerms}
                onChange={this.handleOnChangeAcceptTerms}
              />
              <div className='col-10 col-md-auto pt-2'>
                <p className='txt-body-sm'>
                  Li e aceito os{' '}
                  <a
                    className='txt-body-sm color-brand-2 txt-underline'
                    role='button'
                    onClick={_ => this.setState({ showTerms: true })}
                  >
                    termos do regulamento
                  </a>
                </p>
              </div>
            </div>

            <div className='col-12'>
              <Button
                id={'DoneBill'}
                name={'DoneBill'}
                className='btn-featured btn btn-sm'
                text='Pagar Conta'
                loading={this.state.isSendingPurchase}
                disabled={this.isFormInvalid()}
                onClick={this.handleSendPurchase}
              />
            </div>
          </div>
          {this.state.showTerms &&
            <ModalTerms
              show={this.state.showTerms}
              terms={{
                type: 'Vendor',
                vendorId: this.state.vendorId,
                catalogId: this.props.catalogId
              }}
              onClose={_ => this.setState({ showTerms: false })}
              acceptTerms={() => {
                this.setState({ acceptedTerms: true, showTerms: false })
                this.setPropValidation('acceptedTerms', { valid: true })
              }}
            />
          }
        </div>
        <div
          className='bg-white radius row px-1 mx-0 pt-2 pb-3 border-top-lg border-color-error'
          style={this.state.stepError ? {} : { display: 'none' }}
        >
          <div className='row px-1 mx-0'>
            <div className='col-10'>
              <p className='txt-body my-1'>
                <i className='icon icon_close_circle color-error' />
              </p>
            </div>
            <div className='col-2 pl-3'>
              <i
                className='icon icon_close txt-body-sm cursor'
                onClick={() => this.btnResetSteps()}
              />
            </div>
            <div className='col-12'>
              <p className='txt-body my-1 color-error'>
                Não foi possível concluir o sua transação.
              </p>
              <p className='txt-body-sm my-1'>Seu saldo é insuficiente.</p>
            </div>
            <div className='col-12 mt-1 mb-5 pb-5'>
              <Button
                id={'btnTryAgainBillPayment'}
                name={'TryAgainBillPayment'}
                className='btn-featured btn btn-sm btn-cart mb-5'
                text='TENTAR NOVAMENTE'
                onClick={() => this.btnTryAgain()}
              />
            </div>
          </div>
        </div>
        <div
          className='bg-white radius row px-2 mx-0 pt-2 pb-3 border-top-lg border-color-success'
          style={this.state.stepFinal ? {} : { display: 'none' }}
        >
          <div className='row px-1 mx-0'>
            <div className='col-10'>
              <p className='txt-body my-1'>
                <i className='icon icon_check_circle color-success' />
              </p>
            </div>
            <div className='col-2 pl-3'>
              <i
                className='icon icon_close txt-body-sm cursor'
                onClick={() => this.btnResetSteps()}
              />
            </div>
            <div className='col-12'>
              <p className='txt-body my-1 color-success'>
                Parabéns! Seu resgate foi concluído com sucesso.
              </p>
            </div>
            <div className='col-12 my-1'>
              <p className='txt-body-sm'>
                Resgate realizado em: <strong>{'04/11/2018 às 14h13'}</strong>
              </p>
              <p className='txt-body-sm'>
                Tipo de conta: <strong>{'Conta de luz'}</strong>
              </p>
              <p className='txt-body-sm'>
                Telefone: <strong>11 96284-4068</strong>
              </p>
              <p className='txt-body-sm'>
                Valor da conta: <strong>R$ 300,00</strong>
              </p>
              <p className='txt-body-sm'>
                Valor em pontos: <strong>300 pontos</strong>
              </p>
            </div>
            <div className='col-12 mt-1 mb-2'>
              <Button
                id={'btnTryAgainRecharge'}
                name={'TryAgainRecharge'}
                className='btn-featured btn btn-sm btn-cart mb-5'
                text='Ver detalhes'
                onClick={() => this.btnTryAgain()}
              />
            </div>
          </div>
        </div>
      </div>
    )
  }
}

const mapStateToProps = ({
  participant: { cpf },
  oidc: {
    user: { profile }
  },
  catalog: { currencyConfiguration }
}) => ({
  documentNumber: cpf.value,
  catalogId: profile['custom:catalog_id'],
  pointsValue: currencyConfiguration.pointsName,
  decimalPlaces: currencyConfiguration.decimalPlaces
})

const mapDispatchToProps = dispatch => ({
  redirect: path => dispatch(push(path))
})

BillPayment.propTypes = {
  documentNumber: PropTypes.string.isRequired,
  catalogId: PropTypes.string.isRequired,
  redirect: PropTypes.func.isRequired,
  pointsValue: PropTypes.string,
  decimalPlaces: PropTypes.string
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(BillPayment)



// WEBPACK FOOTER //
// ./src/features/Services/BillPayment/BillPayment.js